export const moneyFormat = (quantity: number, currency: string = 'MXN') => {

    return currency + ' ' + (quantity).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

}